module.exports = __webpack_public_path__ + "img/meetings.e32f7c0c.svg";